import React, { useEffect, useState } from "react";
import BreadCrumb from "../../layout/BreadCrumb";
import svg9 from "../../assets/svg/svg9.svg";
import svg10 from "../../assets/svg/svg10.svg";
import svg11 from "../../assets/svg/svg11.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearObj, setActiveObj } from "../../features/obj/objSlice";
import { fetchData } from "../../features/fetch/fetchSlice";
import CardLoading from "../../components/CardLoading";
import Search from "../../components/Search";
import { Switch, Table } from "antd";
import useModalToggle from "../../custom_hooks/useModalToggle";
import UserAdd from "./UserAdd";
import ConfirmModal from "../../components/ConfirmModal";
import { logout } from "../../features/auth/authSlice";
import toast from "react-hot-toast";
import { save } from "../../features/save/saveSlice";

function UsersList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v1/users/list";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const { open, handleCancel, handleOpen } = useModalToggle();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = () => {};

  const [openConfirm, setOpenConfirm] = useState(false);

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };
  const [content, setContent] = useState();
  
   const [hideEdits, setHideEdits] = useState(user?.hideEdits || false);
 
  useEffect(() => {
    setHideEdits(user?.hideEdits || false);
  }, [user?.hideEdits]);

  const onChange = async(checked) => {
    await setHideEdits(checked);
     await setContent(
      checked
        ? "Are you sure you want to hide buttons in datasetTable ?"
        : "Are you sure you want to show buttons in datasetTable ?"
    );
    await setOpenConfirm(true); 
  };

  async function handleLogout() {
    await dispatch(logout());
    await localStorage.clear();
    await dispatch(clearObj());
    await navigate("/login");
  }
  const handleConfirm = async () => {
    const res = await dispatch(
      save({
        url: "api/v1/users/hide-edits",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleLogout();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        firstname: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const handleEdit = async (item) => {
    await setProdd(item);
    await handleOpen();
  };

  const handleDisable = async (item) => {
    await setProdd(item);
    await handleOpenDelete();
  };
  const handleAdd = async () => {
    await setProdd("");
    await handleOpen();
  };

  const colors = ["#FF5733", "#33FF57"];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
      width: "3%",
    },
    {
      title: "Name",
      render: (item) => {
        return (
          <div onClick={() => handleEdit(item)}>
            {item?.firstname} {item?.lastname}
          </div>
        );
      },
    },

    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },

    {
      title: "Phone",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },

    {
      title: "Role",
      dataIndex: "role",
      sorter: (a, b) => a.role.localeCompare(b.role),
    },

    {
      title: "Permission",
      render: (item) => {
        const colorMap = {
          VIEW: "#4CAF50",
          EDIT: "#2196F3",
        };

        return (
          <div className="flex flex-col">
            {item?.rights?.map((permission, index) => (
              <div key={index} className="flex items-center gap-x-1 mb-1">
                <span
                  className="w-[10px] h-[10px] rounded-full"
                  style={{ backgroundColor: colorMap[permission] || "#9E9E9E" }}
                ></span>
                <div>{permission}</div>
              </div>
            ))}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <div className="flex items-center gap-[1rem]">
          <img
            className="cursor-pointer"
            src={svg10}
            alt="svg10"
            onClick={() => handleEdit(item)}
          />
          <img
            className="cursor-pointer"
            src={svg11}
            alt="svg11"
            onClick={() => handleDisable(item)}
          />
        </div>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <BreadCrumb breadcrumbs={[{ title: "Users" }]} />

      <div className="white_card mt-[1.5rem] flex-1 min-h-[80vh]">
        <div className="flex lg:flex-row flex-col lg:items-center justify-between ">
          <div className="typography_3">Users</div>
          <button
            className="cstm-btn  flex items-center gap-[1rem] !w-[140px]"
            type="button"
            onClick={handleAdd}
          >
            <img src={svg9} alt="svg9" /> Add User
          </button>
        </div>

        <div className="flex items-center justify-between">
          <div className="lg:w-[29.1875rem] w-auto mt-[1.25rem]">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search user..."}
            />
          </div> 
            <Switch onChange={onChange} checked={hideEdits} /> 
        </div>

        <Table
          rowSelection={false}
          className="mt-[2.25rem] w-full"
          scroll={{
            x: "auto",
          }}
          rowKey={(record) => record?.id}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>

      <UserAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        prodd={prodd}
        handleFetch={fetchTableData}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Disable"
      />
      <ConfirmModal
        open={openConfirm}
        handleCancel={handleCloseConfirm}
        handleSubmit={handleConfirm}
        loading={saving}
        content={content}
        type="alert"
        btnTitle="Confirm"
      />
    </>
  );
}

export default UsersList;
